module.exports = __webpack_public_path__ + "static/annual-report-2012-13-9be825f528a86b817997bfb665c1cd2d.pdf";